import * as Yup from "yup";

export type CustomizeFormValues = {
	primaryColor: string;
	pageBackgroundColor: string;
	contentBackgroundColor: string;
	primaryTextColor: string;
	secondaryTextColor: string;
	strokeColor: string;
	buttonBackgroundColor: string;
	buttonTextColor: string;
	buttonShape: number;
	buttonFullWidth: string;
	buttonTextWeight: string;
	mainError: string;
	lightError: string;
	darkError: string;
	showExit?: boolean;
	file?: File;
};

export const defaultFormValues: CustomizeFormValues = {
	primaryColor: "",
	pageBackgroundColor: "",
	contentBackgroundColor: "",
	primaryTextColor: "",
	secondaryTextColor: "",
	strokeColor: "",
	buttonBackgroundColor: "",
	buttonTextColor: "",
	buttonShape: 0,
	buttonFullWidth: "100%",
	buttonTextWeight: "",
	mainError: "",
	lightError: "",
	darkError: ""
};

export const customizeFormSchema = (translate: any) => {
	return Yup.object().shape({
		primaryColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		pageBackgroundColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		contentBackgroundColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		primaryTextColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		secondaryTextColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		strokeColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		buttonBackgroundColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		buttonTextColor: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		mainError: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		lightError: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),
		darkError: Yup.string()
			.required(translate("customization.add_color"))
			.matches(/^#(?:[0-9a-fA-F]{3}){1,2}$/, translate("customization.add_correct_color")),

		buttonShape: Yup.number().required(""),
		buttonFullWidth: Yup.string().required(""),
		buttonTextWeight: Yup.string().required("")
	});
};
